import http from "./http-common";

class GarDivDataService {
  getDivsByUai(uai) {
    return http.get(`/garDiv/uai/${uai}`);
  }

  addSequence(idSequence, idDiv) {
    return http.get(`/garDiv/addSequence/${idSequence}/${idDiv}`);
  }

  removeSequence(idSequence, idDiv) {
    return http.get(`/garDiv/removeSequence/${idSequence}/${idDiv}`);
  }
}

export default new GarDivDataService();
